import { render, staticRenderFns } from "./HowToTour.vue?vue&type=template&id=3823e82c&scoped=true&lang=pug"
import script from "./HowToTour.vue?vue&type=script&lang=js"
export * from "./HowToTour.vue?vue&type=script&lang=js"
import style0 from "./HowToTour.vue?vue&type=style&index=0&id=3823e82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3823e82c",
  null
  
)

export default component.exports